import React, { useState } from "react";
import styles from "./Gallery.module.css";
import imageclocktower2 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/3.JPG";
import imageclocktower3 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/4.JPG"; 
import imageclocktower4 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/5.JPG"; 
import imageclocktower5 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/6.JPG"; 
import imageclocktower6 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/7.JPG"; 
import imageclocktower7 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/8.JPG";
import imageclocktower8 from "../../assets/gallery/constructions/Clock Tower - Nuwara Eliya/9.JPG";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageDPMC2 from "../../assets/gallery/constructions/David Peris Motor Company - Ranna, Hambanthota/2.jpg";
import imageDPMC3 from "../../assets/gallery/constructions/David Peris Motor Company - Ranna, Hambanthota/3.jpg";
import imageDPMC4 from "../../assets/gallery/constructions/David Peris Motor Company - Ranna, Hambanthota/4.jpg";
import imageDPMC6 from "../../assets/gallery/constructions/David Peris Motor Company - Ranna, Hambanthota/6.jpg";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageDSBM from "../../assets/gallery/constructions/District Secratarial Building - Matale/1.jpg";
import imageDSBM2 from "../../assets/gallery/constructions/District Secratarial Building - Matale/2.jpg";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageDSBP from "../../assets/gallery/constructions/District Secratarial Building - Polonnaruwa/1.jpg";
import imageDSBP2 from "../../assets/gallery/constructions/District Secratarial Building - Polonnaruwa/2.jpg";
import imageDSBP3 from "../../assets/gallery/constructions/District Secratarial Building - Polonnaruwa/3.jpg";  
import imageDSBP4 from "../../assets/gallery/constructions/District Secratarial Building - Polonnaruwa/4.jpg";
import imageDSBP5 from "../../assets/gallery/constructions/District Secratarial Building - Polonnaruwa/5.jpg";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageTangalle from "../../assets/gallery/constructions/Hotel Anantara - Tangalle/1.JPG";
import imageTangalle2 from "../../assets/gallery/constructions/Hotel Anantara - Tangalle/2.JPG";
import imageTangalle3 from "../../assets/gallery/constructions/Hotel Anantara - Tangalle/3.JPG";
import imageTangalle4 from "../../assets/gallery/constructions/Hotel Anantara - Tangalle/4.JPG";
import imageTangalle5 from "../../assets/gallery/constructions/Hotel Anantara - Tangalle/5.JPG";
import imageTangalle6 from "../../assets/gallery/constructions/Hotel Anantara - Tangalle/6.JPG";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageH7 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/1.JPG";
import imageH72 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/2.JPG";
import imageH73 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/3.JPG";
import imageH74 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/4.JPG";
import imageH75 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/5.JPG";
import imageH76 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/6.JPG";
import imageH77 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/7.JPG";
import imageH78 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/8.JPG";
import imageH79 from "../../assets/gallery/constructions/Hotel Heaven Seven - Nuwara Eliya/9.JPG";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageM from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/1.jpg";
import imageM2 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/2.jpg";
import imageM3 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/3.jpg";
import imageM4 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/4.jpg";
import imageM5 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/5.jpg";
import imageM6 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/6.jpg";
import imageM7 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/7.jpg";
import imageM8 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/8.jpg";
import imageM9 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/9.jpg";
import imageM10 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/10.jpg";
import imageM11 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/11.jpg";
import imageM12 from "../../assets/gallery/constructions/Hotel Maradha - Kollupitiya/55.jpg";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageH from "../../assets/gallery/constructions/Hotel Topaz - Kandy/1.JPG";
import imageH2 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/2.JPG";
import imageH3 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/3.JPG";
import imageH4 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/4.JPG";
import imageH5 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/5.JPG";
import imageH6 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/6.JPG";
import imageH722 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/7.JPG";
import imageH8 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/8.JPG";
import imageH9 from "../../assets/gallery/constructions/Hotel Topaz - Kandy/9.JPG";
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageT from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/1.jpeg";
import imageT2 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/2.jpeg";
import imageT3 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/3.jpeg";
import imageT4 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/4.jpeg";
import imageT5 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/5.jpeg";
import imageT6 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/6.jpeg";
import imageT7 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/7.jpeg";
import imageT8 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/8.jpeg";
import imageT9 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/9.jpeg";
import imageT10 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/10.jpeg";
import imageT11 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Anuradhapura/11.jpeg";
// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageTK1 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Kaduwela/1.jpg";
import imageTK2 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Kaduwela/2.jpg";
import imageTK3 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Kaduwela/3.jpg";
import imageTK4 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Kaduwela/4.jpg";
import imageTK5 from "../../assets/gallery/constructions/Mahamevnawa Amawatura Monastery - Kaduwela/5.jpg";

// Importing images for housing projects
import imageImported1 from "../../assets/gallery/housing/Imported Stones/1.jpg";
import imageImported2 from "../../assets/gallery/housing/Imported Stones/2.jpg";
import imageImported3 from "../../assets/gallery/housing/Imported Stones/3.jpg";
import imageImported4 from "../../assets/gallery/housing/Imported Stones/4.JPG";
import imageImported5 from "../../assets/gallery/housing/Imported Stones/5.JPG";
import imageImported6 from "../../assets/gallery/housing/Imported Stones/6.JPG";
import imageImported7 from "../../assets/gallery/housing/Imported Stones/7.JPG";
import imageImported8 from "../../assets/gallery/housing/Imported Stones/8.jpg";
import imageImported9 from "../../assets/gallery/housing/Imported Stones/9.jpg";
import imageImported10 from "../../assets/gallery/housing/Imported Stones/10.jpg";
import imageImported11 from "../../assets/gallery/housing/Imported Stones/11.jpg";
import imageImported12 from "../../assets/gallery/housing/Imported Stones/12.jpg";
import imageImported13 from "../../assets/gallery/housing/Imported Stones/13.jpg";
import imageImported14 from "../../assets/gallery/housing/Imported Stones/14.jpg";
import imageImported15 from "../../assets/gallery/housing/Imported Stones/15.jpg";
import imageImported16 from "../../assets/gallery/housing/Imported Stones/16.jpg";
import imageImported17 from "../../assets/gallery/housing/Imported Stones/17.jpg";
import imageImported18 from "../../assets/gallery/housing/Imported Stones/18.jpg";
import imageImported19 from "../../assets/gallery/housing/Imported Stones/19.jpg";
import imageImported20 from "../../assets/gallery/housing/Imported Stones/20.jpg";
import imageImported21 from "../../assets/gallery/housing/Imported Stones/21.jpg";
import imageImported22 from "../../assets/gallery/housing/Imported Stones/22.jpg";
import imageImported23 from "../../assets/gallery/housing/Imported Stones/23.jpg";
import imageImported24 from "../../assets/gallery/housing/Imported Stones/24.jpg";
import imageImported25 from "../../assets/gallery/housing/Imported Stones/25.jpg";
import imageImported26 from "../../assets/gallery/housing/Imported Stones/26.jpg";
// /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageEmbossed1 from "../../assets/gallery/housing/Local Stones/12 X 6 Embossed Stone/1.JPG";
import imageEmbossed2 from "../../assets/gallery/housing/Local Stones/12 X 6 Embossed Stone/2.JPG";
// import imageEmbossed3 from "../../assets/gallery/housing/Local Stones/12 X 6 Embossed Stone/3.JPG";
// import imageEmbossed4 from "../../assets/gallery/housing/Local Stones/12 x 6 Embossed Stone/4.JPG";
// import imageEmbossed5 from "../../assets/gallery/housing/Local Stones/12 x 6 Embossed Stone/5.JPG";
// import imageEmbossed6 from "../../assets/gallery/housing/Local Stones/12 x 6 Embossed Stone/6.JPG";
// import imageEmbossed7 from "../../assets/gallery/housing/Local Stones/12 x 6 Embossed Stone/7.jpg";
// import imageEmbossed8 from "../../assets/gallery/housing/Local Stones/12 x 6 Embossed Stone/8.jpg";
// import imageEmbossed9 from "../../assets/gallery/housing/Local Stones/12 x 6 Embossed Stone/9.jpg";
// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import image1212stone from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/1.JPG";
import image1212stone2 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/2.JPG";
import image1212stone3 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/3.JPG";
import image1212stone4 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/4.JPG";
import image1212stone5 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/5.JPG";
import image1212stone6 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/6.JPG";
import image1212stone7 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/7.JPG";
import image1212stone8 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/8.JPG";
import image1212stone9 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/9.JPG";
import image1212stone10 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/10.JPG";
import image1212stone11 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/11.JPG";
import image1212stone12 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/12.JPG";
import image1212stone13 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/13.JPG";
import image1212stone14 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/14.JPG";
import image1212stone15 from "../../assets/gallery/housing/Local Stones/12 X 12 Stone/15.jpg";
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imageblackgrey from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/1.png";
import imageblackgrey2 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/2.jpg";
import imageblackgrey3 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/3.jpg";
import imageblackgrey4 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/4.jpg";
import imageblackgrey5 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/5.jpg";
import imageblackgrey6 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/6.jpg";
import imageblackgrey7 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/7.jpg";
import imageblackgrey8 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/8.jpg";
import imageblackgrey9 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/9.jpg";
import imageblackgrey10 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/10.JPG";
import imageblackgrey11 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/11.JPG";
import imageblackgrey12 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/12.JPG";
import imageblackgrey13 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/13.JPG";
import imageblackgrey14 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/14.JPG";
import imageblackgrey15 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/15.JPG";
import imageblackgrey16 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/16.JPG";
import imageblackgrey17 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/17.JPG";
import imageblackgrey18 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/18.JPG";
import imageblackgrey19 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/19.JPG";
import imageblackgrey20 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/20.JPG";
import imageblackgrey21 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/21.JPG";
import imageblackgrey22 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/22.JPG";
import imageblackgrey23 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/23.JPG";
import imageblackgrey24 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/24.JPG";
import imageblackgrey25 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/25.JPG";
import imageblackgrey26 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/26.JPG";
import imageblackgrey27 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/27.JPG";
import imageblackgrey28 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/28.jpg";
import imageblackgrey29 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/29.jpg";
import imageblackgrey30 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/30.jpg";
import imageblackgrey31 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/31.jpg";
import imageblackgrey32 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/32.jpg";
import imageblackgrey33 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/33.jpg";
import imageblackgrey34 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/34.jpg";
import imageblackgrey35 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/35.jpg";
import imageblackgrey36 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/36.jpg";
import imageblackgrey37 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/37.jpg";
import imageblackgrey38 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/38.jpg";
import imageblackgrey39 from "../../assets/gallery/housing/Local Stones/Black Gray White Uneven/39.jpg";
// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import imagecolour1 from "../../assets/gallery/housing/Local Stones/Colour Stones/1.jpg";
import imagecolour2 from "../../assets/gallery/housing/Local Stones/Colour Stones/2.jpg";
import imagecolour3 from "../../assets/gallery/housing/Local Stones/Colour Stones/3.jpg";
import imagecolour4 from "../../assets/gallery/housing/Local Stones/Colour Stones/4.jpg";
import imagecolour5 from "../../assets/gallery/housing/Local Stones/Colour Stones/5.jpg";
import imagecolour6 from "../../assets/gallery/housing/Local Stones/Colour Stones/6.jpg";
import imagecolour7 from "../../assets/gallery/housing/Local Stones/Colour Stones/7.JPG";
import imagecolour8 from "../../assets/gallery/housing/Local Stones/Colour Stones/8.JPG";
import imagecolour9 from "../../assets/gallery/housing/Local Stones/Colour Stones/9.JPG";
import imagecolour10 from "../../assets/gallery/housing/Local Stones/Colour Stones/10.JPG";
import imagecolour11 from "../../assets/gallery/housing/Local Stones/Colour Stones/11.JPG";
import imagecolour12 from "../../assets/gallery/housing/Local Stones/Colour Stones/12.JPG";
import imagecolour13 from "../../assets/gallery/housing/Local Stones/Colour Stones/13.JPG";
import imagecolour14 from "../../assets/gallery/housing/Local Stones/Colour Stones/14.JPG";
import imagecolour15 from "../../assets/gallery/housing/Local Stones/Colour Stones/15.JPG";
import imagecolour16 from "../../assets/gallery/housing/Local Stones/Colour Stones/16.JPG";
import imagecolour17 from "../../assets/gallery/housing/Local Stones/Colour Stones/17.JPG";
import imagecolour18 from "../../assets/gallery/housing/Local Stones/Colour Stones/18.JPG";
import imagecolour19 from "../../assets/gallery/housing/Local Stones/Colour Stones/19.JPG";
import imagecolour20 from "../../assets/gallery/housing/Local Stones/Colour Stones/20.JPG";
import imagecolour21 from "../../assets/gallery/housing/Local Stones/Colour Stones/21.JPG";
import imagecolour22 from "../../assets/gallery/housing/Local Stones/Colour Stones/22.JPG";
import imagecolour23 from "../../assets/gallery/housing/Local Stones/Colour Stones/23.JPG";
import imagecolour24 from "../../assets/gallery/housing/Local Stones/Colour Stones/24.JPG";
import imagecolour25 from "../../assets/gallery/housing/Local Stones/Colour Stones/25.JPG";






//,imageEmbossed3,imageEmbossed4,imageEmbossed5,imageEmbossed6,imageEmbossed7,imageEmbossed8,imageEmbossed9
const housingProjects = [
  {
    title: "Houses with Imported Stones",
    images: [imageImported1,imageImported2,imageImported3,imageImported4,imageImported5,imageImported6,imageImported7,imageImported8,imageImported9,imageImported10,imageImported11,imageImported12,imageImported13,imageImported14,imageImported15,imageImported16,imageImported17,imageImported18,imageImported19,imageImported20,imageImported21,imageImported22,imageImported23,imageImported24,imageImported25,imageImported26], // Multiple images for slideshow
    info: "A luxurious residence that combines imported stone with modern design elements. The intricate stonework and elegant finishes create a home that is both stylish and timeless.",
    year: "Est. 2023"
  },
  {
    title: "Houses with Local Stones (12 x 6 Emboessed Stone)",
    images: [imageEmbossed1,imageEmbossed2], // Multiple images for slideshow
    info: "A stunning residence that showcases the beauty of locally sourced stone. The embossed finish adds a unique texture, while the craftsmanship reflects our commitment to quality and sustainability.",
    year: "Est. 2022"
  },
  {
    title: "Houses with Local Stones (12 x 12 Stone)",
    images: [image1212stone,image1212stone2,image1212stone3,image1212stone4,image1212stone5,image1212stone6,image1212stone7,image1212stone8,image1212stone9,image1212stone10,image1212stone11,image1212stone12,image1212stone13,image1212stone14,image1212stone15], // Multiple images for slideshow
    info: "A contemporary home that harmonizes with its natural surroundings. The use of local stone not only enhances the aesthetic appeal but also promotes environmental sustainability.",
    year: "Est. 2021"
  },
  {
    title: "Houses with Local Stones (Black Gray White Uneven)",
    images: [imageblackgrey,imageblackgrey2,imageblackgrey3,imageblackgrey4,imageblackgrey5,imageblackgrey6,imageblackgrey7,imageblackgrey8,imageblackgrey9,imageblackgrey10,imageblackgrey11,imageblackgrey12,imageblackgrey13,imageblackgrey14,imageblackgrey15,imageblackgrey16,imageblackgrey17,imageblackgrey18,imageblackgrey19,imageblackgrey20,imageblackgrey21,imageblackgrey22,imageblackgrey23,imageblackgrey24,imageblackgrey25,imageblackgrey26,imageblackgrey27,imageblackgrey28,imageblackgrey29,imageblackgrey30,imageblackgrey31,imageblackgrey32,imageblackgrey33,imageblackgrey34,imageblackgrey35,imageblackgrey36,imageblackgrey37,imageblackgrey38,imageblackgrey39], // Multiple images for slideshow
    info: "A modern residence that features a striking combination of black, gray, and white stones. The uneven texture adds depth and character, making it a standout in any neighborhood.",
    year: "Est. 2020"
  }
  ,
  {
    title: "Houses with Local Stones (Colour Stones)",
    images: [imagecolour1,imagecolour2,imagecolour3,imagecolour4,imagecolour5,imagecolour6,imagecolour7,imagecolour8,imagecolour9,imagecolour10,imagecolour11,imagecolour12,imagecolour13,imagecolour14,imagecolour15,imagecolour16,imagecolour17,imagecolour18,imagecolour19,imagecolour20,imagecolour21,imagecolour22,imagecolour23,imagecolour24,imagecolour25], // Multiple images for slideshow
    info: "A vibrant residence that showcases the beauty of color in stone. The carefully selected stones create a stunning visual impact, making this home a true work of art.",
    year: "Est. 2020"
  }
  
];

const constructionProjects = [
  {
    title: "Clock Tower - Nuwara Eliya",
    images: [imageclocktower8,imageclocktower7, imageclocktower2, imageclocktower3, imageclocktower4, imageclocktower5, imageclocktower6],
    info: "Our signature stone clock tower stands as a testament to architectural excellence. Featuring hand-carved stone details and traditional joinery techniques, this structure demonstrates our dedication to reviving the grandeur of Victorian public monuments.",
    year: "Est. 2021"
  },
  {
    title: "David Peris Motor Company - Ranna, Hambanthota",
    images: [ imageDPMC2, imageDPMC3, imageDPMC4, imageDPMC6],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "District Secratarial Building - Matale",
    images: [imageDSBM, imageDSBM2],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "District Secratarial Building - Polonnaruwa",
    images: [imageDSBP, imageDSBP2, imageDSBP3, imageDSBP4, imageDSBP5],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "Hotel Anantara - Tangalle",
    images: [imageTangalle, imageTangalle2, imageTangalle3, imageTangalle4, imageTangalle5, imageTangalle6],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "Hotel Heaven Seven - Nuwara Eliya",
    images: [imageH7, imageH72, imageH73, imageH74, imageH75, imageH76, imageH77, imageH78, imageH79],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "Hotel Maradha - Kollupitiya",
    images: [ imageM2,imageM, imageM3, imageM4, imageM5,  imageM12,imageM6, imageM7, imageM8, imageM9, imageM10, imageM11],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "Hotel Topaz - Kandy",
    images: [imageH, imageH2, imageH3, imageH4, imageH5, imageH6, imageH722, imageH8, imageH9],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "Mahamevnawa Amawatura Monastery - Anuradhapura",
    images: [imageT, imageT2, imageT3, imageT4, imageT5, imageT6, imageT7, imageT8, imageT9, imageT10, imageT11],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },
  {
    title: "Mahamevnawa Amawatura Monastery - Kaduwela",
    images: [imageTK1, imageTK2, imageTK3, imageTK4, imageTK5],
    info: "Commissioned for the central park, this pavilion draws inspiration from Victorian gardens found in noble estates. Constructed using locally quarried stone selected for its exceptional quality, this structure combines durability with timeless elegance.",
    year: "Est. 2020"
  },

];

const Gallery = () => {
  const [type, setType] = useState("housing");
  const projects = type === "housing" ? housingProjects : constructionProjects;
  const [currentImageIndexes, setCurrentImageIndexes] = useState(projects.map(() => 0));

  const nextImage = (projectIndex) => {
    setCurrentImageIndexes(prev => {
      const newIndexes = [...prev];
      newIndexes[projectIndex] = (newIndexes[projectIndex] + 1) % projects[projectIndex].images.length;
      return newIndexes;
    });
  };

  const prevImage = (projectIndex) => {
    setCurrentImageIndexes(prev => {
      const newIndexes = [...prev];
      newIndexes[projectIndex] = (newIndexes[projectIndex] - 1 + projects[projectIndex].images.length) % projects[projectIndex].images.length;
      return newIndexes;
    });
  };

  return (
    <div className={styles.gallery}>
      <div className={styles.galleryHeader}>
        <h1>Distinguished Portfolio</h1>
        <p>Bespoke stonework of exceptional quality since 1892</p>
      </div>
      
      <div className={styles.tabs}>
        <button
          className={type === "housing" ? styles.active : ""}
          onClick={() => {
            setType("housing");
            setCurrentImageIndexes(housingProjects.map(() => 0));
          }}
        >
          Housing Projects
        </button>
        <button
          className={type === "construction" ? styles.active : ""}
          onClick={() => {
            setType("construction");
            setCurrentImageIndexes(constructionProjects.map(() => 0));
          }}
        >
          Construction Projects
        </button>
      </div>
      
      <div className={styles.projectsContainer}>
        {projects.map((project, projectIndex) => (
          <div 
            key={projectIndex} 
            className={`${styles.projectRow} ${projectIndex % 2 === 1 ? styles.reversed : ''}`}
          >
            <div className={styles.projectImage}>
              <button 
                className={styles.arrowButton} 
                onClick={() => prevImage(projectIndex)}
                aria-label="Previous image"
              >
                &lt;
              </button>
              
              <div className={styles.imageWrapper}>
                <img 
                  src={project.images[currentImageIndexes[projectIndex]]} 
                  alt={project.title} 
                />
                <div className={styles.imageCounter}>
                  {currentImageIndexes[projectIndex] + 1} / {project.images.length}
                </div>
              </div>
              
              <button 
                className={styles.arrowButton} 
                onClick={() => nextImage(projectIndex)}
                aria-label="Next image"
              >
                &gt;
              </button>
            </div>
            
            <div className={styles.projectInfo}>
              <h2>{project.title}</h2>
              <div className={styles.divider}></div>
              <p>{project.info}</p>
              <span className={styles.yearMark}>{project.year}</span>
            
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;